import {
  Incubation,
  Measurement,
} from "@/services/backend/procedures/procedure/procedure";
import {
  EvaluableType,
  SampleError,
} from "@/services/backend/sample-error/sample-error";
import { SampleSet } from "@/services/backend/sample-set/sample-set";
import { useGetSampleSetQuery } from "@/services/backend/sample-set/service";
import { RTKQueryErrorAlert } from "@/shared/components/domain/errors/rtk-query-error-alert";
import { Badge } from "@/shared/components/ui/badge";

function checkIfNotEvaluable(sampleSet: SampleSet | undefined): boolean {
  if (sampleSet != null) {
    const errors: SampleError[] = [];
    sampleSet.samples.forEach((s) =>
      s.sampleErrors.forEach((e) => errors.push(e)),
    );

    const notEvaluable = errors.some(
      (e) => e.evaluableType === EvaluableType.NotEvaluable,
    );

    return notEvaluable;
  }
  return false;
}

interface MeasurementLabelComponentProps {
  sampleSetId: string;
  incubation: Incubation;
  correctedValue?: boolean;
}

function MeasurementLabelComponent({
  sampleSetId,
  incubation,
  correctedValue = false,
}: MeasurementLabelComponentProps) {
  const { data: sampleSet, error: sampleSetError } = useGetSampleSetQuery({
    id: sampleSetId,
  });
  const measurement = incubation.measurements.find(
    (measure: Measurement) => measure.isCurrent,
  );

  const notEvaluable = checkIfNotEvaluable(sampleSet);

  if (sampleSetError) {
    return <RTKQueryErrorAlert error={sampleSetError} />;
  }

  if (notEvaluable) {
    return <Badge className="bg-red-600">n.a.</Badge>;
  }

  if (measurement == null || measurement.measurement == null) {
    if (measurement?.exceedsThreshold) {
      if (correctedValue) {
        return <span>-</span>;
      }
      return <span>&gt;100</span>;
    }
    return <span>Keine Zählung gefunden</span>;
  }

  return (
    <div className="flex space-x-4">
      {correctedValue ? (
        <div className="flex flex-row space-x-2">
          {measurement.correctedMeasurement}
        </div>
      ) : (
        <div className="flex flex-row space-x-2">{measurement.measurement}</div>
      )}
    </div>
  );
}

export default MeasurementLabelComponent;
